import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../context/LanguageContext';

const HeroCarousel = ({ onLoginClick }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const { tArray, t } = useLanguage();

  const slidesData = tArray('hero.slides');
  const slides = slidesData.map((slide, index) => ({
    id: index + 1,
    title: slide.title,
    subtitle: slide.subtitle,
    bgImage: [
      "/images/hero/slide-1-projects.jpg",
      "/images/hero/slide-2-budget.jpg",
      "/images/hero/slide-3-personnel.jpg",
      "/images/hero/slide-4-equipment.jpg",
      "/images/hero/slide-5-operations.jpg"
    ][index] || "/images/hero/slide-1-projects.jpg",
    bgColor: [
      "linear-gradient(135deg, var(--archon-navy-deep) 0%, var(--archon-blue-mid) 100%)",
      "linear-gradient(135deg, var(--archon-blue-mid) 0%, var(--archon-blue) 100%)",
      "linear-gradient(135deg, var(--archon-blue-light) 0%, var(--archon-blue-mid) 100%)",
      "linear-gradient(135deg, var(--archon-blue) 0%, var(--archon-navy-deep) 100%)",
      "linear-gradient(135deg, var(--archon-navy-deep) 0%, var(--archon-blue-light) 100%)"
    ][index] || "linear-gradient(135deg, var(--archon-navy-deep) 0%, var(--archon-blue-mid) 100%)"
  }));

  useEffect(() => {
    if (!isPaused) {
      const interval = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % slides.length);
      }, 5000);

      return () => clearInterval(interval);
    }
  }, [isPaused, slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const handleGetStarted = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      // Dispatch custom event to open the contact form
      window.dispatchEvent(new CustomEvent('openContactForm'));
    }
  };

  const scrollToProduct = () => {
    const element = document.getElementById('product');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div 
      className="hero-carousel"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      {slides.map((slide, index) => (
        <div
          key={slide.id}
          className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
          style={{ 
            backgroundImage: `url(${slide.bgImage})`,
            backgroundColor: slide.bgColor.split('(')[1]?.split(' ')[0] || 'var(--archon-navy-deep)'
          }}
        >
          <div className="hero-overlay"></div>
          <div className="hero-content">
            <h1 className="hero-title">{slide.title}</h1>
            <p className="hero-subtitle">{slide.subtitle}</p>
            <div className="hero-cta">
              <button 
                className="hero-btn-primary"
                onClick={handleGetStarted}
              >
                {t('hero.getStarted')}
              </button>
              <button 
                className="hero-btn-secondary"
                onClick={scrollToProduct}
              >
                {t('hero.learnMore')}
              </button>
            </div>
          </div>
        </div>
      ))}

      {/* Navigation Arrows */}
      <button 
        className="carousel-arrow left"
        onClick={prevSlide}
        aria-label="Previous slide"
      >
        ‹
      </button>
      <button 
        className="carousel-arrow right"
        onClick={nextSlide}
        aria-label="Next slide"
      >
        ›
      </button>

      {/* Dots Navigation */}
      <div className="carousel-controls">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`carousel-dot ${index === currentSlide ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default HeroCarousel;
